import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!CLERK_PUBLISHABLE_KEY) {
  // Don't crash silently — make the missing-env-var case obvious in dev.
  root.render(
    <div
      style={{
        minHeight: "100dvh",
        backgroundColor: "#0f0e0c",
        color: "#ffb3ab",
        fontFamily: "ui-monospace, monospace",
        padding: 24,
        fontSize: 13,
        lineHeight: 1.6,
      }}
    >
      <strong style={{ color: "#e8634a" }}>// Ledger config error</strong>
      <br />
      REACT_APP_CLERK_PUBLISHABLE_KEY is not set in frontend/.env.
      <br />
      Restart the dev server after adding it.
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    </React.StrictMode>,
  );
}

// Register the Ledger service worker for PWA offline-ish support.
// We defer registration until `load` to keep first paint fast. In dev
// (CRA `npm start`) the worker still registers so you can test install
// flows; bump the VERSION in /public/sw.js to invalidate old caches.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      // eslint-disable-next-line no-console
      .then((reg) => console.log("[Ledger] SW registered:", reg.scope))
      // eslint-disable-next-line no-console
      .catch((err) => console.warn("[Ledger] SW registration failed:", err));
  });
}
